import { apiRequestAuth as authRequest} from './index';
export async function getUserList(options?: { [key: string]: any }) {
  const { data } = await authRequest.get('/user', {
    params: { ...(options || {}) },
  });
  return data;
}
export async function fetchUserType(body?: any) {
  const { data } = await authRequest.post('/user/userType', {
    ...body,
  });
  return data;
}
export async function getSingleUserById(id: any) {
  const { data } = await authRequest.get(`/user/${id}`);
  return data;
}
export async function addUser(body: any) {
  const { data } = await authRequest.post('/user', body);
  return data;
}
export async function updateUserById(body: any,id:string) {
  const { data } = await authRequest.put(`/user/${id}`,body);
  return data;
}
export async function userAutocompleteSearch(body: any) {
  const { data } = await authRequest.post('/user/autoComplete', {
    ...body,
  });
  return data;
}
export async function getNotifications(options?: { [key: string]: any }) {
  const { data } = await authRequest.get('/announcement/getAll', {
    params: { ...(options || {}) },
  });
  return data;
}
export async function getSingleStaffById(id: any) {
  const { data } = await authRequest.get(`/staff/${id}`);
  return data;
}
export async function addStaff(body: any) {
  const { data } = await authRequest.post('/staff', body);
  return data;
}
export async function updateStaffById(body: any,id:string) {
  const { data } = await authRequest.put(`/staff/${id}`,body);
  return data;
}

export async function getStaffList(body: any) {
  const { data } = await authRequest.post('/staff/list', body);
  return data;
}